'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@repo/ui/components/ui/alert-dialog';
import { Input } from '@repo/ui/components/ui/input';
import { Check, Copy } from '@repo/ui/icons';
import { useEffect, useState } from 'react';
const COPY_ERROR_MESSAGE = 'Couldn’t copy the link. Select it and copy it manually.';
export const CreatedCustomerSetupLinkDialog = t0 => {
  const $ = _c(29);
  const {
    onClose,
    url
  } = t0;
  const [copied, setCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);
  const [shownUrl, setShownUrl] = useState(url);
  if (shownUrl !== url) {
    setShownUrl(url);
    setCopied(false);
    setCopyFailed(false);
  }
  let t1;
  let t2;
  if ($[0] !== copied) {
    t1 = () => {
      if (!copied) {
        return;
      }
      const timeout = window.setTimeout(() => setCopied(false), 2000);
      return () => window.clearTimeout(timeout);
    };
    t2 = [copied];
    $[0] = copied;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== url) {
    t3 = async () => {
      if (!url) {
        return;
      }
      setCopyFailed(false);
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
      } catch {
        setCopied(false);
        setCopyFailed(true);
      }
    };
    $[3] = url;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCopy = t3;
  let t4;
  if ($[5] !== onClose) {
    t4 = open => open ? undefined : onClose();
    $[5] = onClose;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = Boolean(url);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <AlertDialogHeader data-sentry-element="AlertDialogHeader" data-sentry-source-file="created-customer-setup-link-dialog.tsx"><AlertDialogTitle data-sentry-element="AlertDialogTitle" data-sentry-source-file="created-customer-setup-link-dialog.tsx">Customer setup link created</AlertDialogTitle><AlertDialogDescription data-sentry-element="AlertDialogDescription" data-sentry-source-file="created-customer-setup-link-dialog.tsx">Your customer setup link is ready. Copy and share it with the customer.</AlertDialogDescription></AlertDialogHeader>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = url ?? "";
  let t8;
  if ($[8] !== t7) {
    t8 = <Input aria-label="Customer setup link" onFocus={_temp} readOnly={true} value={t7} data-sentry-element="Input" data-sentry-source-file="created-customer-setup-link-dialog.tsx" />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== copyFailed) {
    t9 = copyFailed ? <p className="text-sm text-destructive" role="alert">{COPY_ERROR_MESSAGE}</p> : null;
    $[10] = copyFailed;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <AlertDialogCancel data-sentry-element="AlertDialogCancel" data-sentry-source-file="created-customer-setup-link-dialog.tsx">Done</AlertDialogCancel>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== handleCopy) {
    t11 = () => void handleCopy();
    $[13] = handleCopy;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== copied) {
    t12 = copied ? <Check data-icon="inline-start" /> : <Copy data-icon="inline-start" />;
    $[15] = copied;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = copied ? "Copied" : "Copy link";
  let t14;
  if ($[17] !== t11 || $[18] !== t12 || $[19] !== t13) {
    t14 = <AlertDialogFooter data-sentry-element="AlertDialogFooter" data-sentry-source-file="created-customer-setup-link-dialog.tsx">{t10}<AlertDialogAction onClick={t11} type="button" data-sentry-element="AlertDialogAction" data-sentry-source-file="created-customer-setup-link-dialog.tsx">{t12}{t13}</AlertDialogAction></AlertDialogFooter>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t8 || $[23] !== t9) {
    t15 = <AlertDialogContent data-sentry-element="AlertDialogContent" data-sentry-source-file="created-customer-setup-link-dialog.tsx">{t6}{t8}{t9}{t14}</AlertDialogContent>;
    $[21] = t14;
    $[22] = t8;
    $[23] = t9;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15 || $[26] !== t4 || $[27] !== t5) {
    t16 = <AlertDialog onOpenChange={t4} open={t5} data-sentry-element="AlertDialog" data-sentry-component="CreatedCustomerSetupLinkDialog" data-sentry-source-file="created-customer-setup-link-dialog.tsx">{t15}</AlertDialog>;
    $[25] = t15;
    $[26] = t4;
    $[27] = t5;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
};
function _temp(event) {
  return event.currentTarget.select();
}